import Script from 'next/script'

export const GoogleOneTapScript = () => (
  <Script src="https://accounts.google.com/gsi/client" strategy="beforeInteractive" async defer />
)
